// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2_1b8","tab":"ProcedureTabs_tab__2JddS"};